import React from "react";
import HtmlBlock from "../../../components/htmlBlock/htmlBlock";
import Image from "../../../components/image/image";
import Link from "../../../components/link/link";
import { deviceIntro, deviceIntro__content, deviceIntro__links } from "./deviceIntro.module.scss";

const DeviceIntro = ({ children, description, image, links, linkStyle, title }) => {
  return (
    <div className={`deviceIntro ${deviceIntro}`}>
      {title && <HtmlBlock tag="h1" data={title} />}
      {image && image.length > 0 && (
        <Image
          lazyload={false}
          className="deviceIntro__img"
          data={image ? image[0] : ''}
        />
      )}
      <div className={`${deviceIntro__content} deviceIntro__content`}>
        {description && <HtmlBlock data={description} />}
        {links.length > 0 && (
          <div className={`deviceIntro__links ${deviceIntro__links}`}>
            {links.map((link, i) => (
              i === 0 ? (
                <Link
                  className="btn--primary"
                  data={link}
                  key={i}
                />
              ) : i === 1 ? (
                <Link
                  className="btn--tertiary"
                  data={link}
                  key={i}
                />
              ) : (
                <div key={i}>
                  <Link
                    className="link--featured--primary"
                    data={link}
                  />
                </div>
              )
            ))}
          </div>
        )}
      </div>
      {children}
    </div>
  );
};





export default DeviceIntro;




